import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { Button, EmptyState } from '@kainos/ui';
import { messageForError } from '@/lib/api';

/** Rendered by the router when a loader or a nested route throws. */
export function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();

  const description = isRouteErrorResponse(error)
    ? `${error.status} — ${error.statusText}`
    : messageForError(error);

  return (
    <EmptyState
      title="No pudimos cargar esta página"
      description={description}
      action={
        <Button variant="primary" onClick={() => navigate('/')}>
          Volver al inicio
        </Button>
      }
    />
  );
}
